import { useEffect } from 'react';
import { useUserContext } from '@/context/userContext';
import { useAuthenticator } from '@aws-amplify/ui-react';

export const useUser = () => {
  const { _init, userIsSet, ...rest } = useUserContext();
  const { authStatus } = useAuthenticator();

  // after a successful sign in, initialize the user context
  useEffect(() => {
    if (!userIsSet && authStatus === 'authenticated') {
      _init();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStatus]);

  return { authStatus, userIsSet, ...rest };
};
